import React from 'react';
import '../../styles/activities/Activities.css';
export default function PopActivitie(props) {

    const {close, title, desc,image} = props;
    const styles = {
        backgroundImage: `url(${image})`,
        backgroundSize : "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    }
  return (
    <section className='Activities-popup' >
           <div className='popup-container' data-aos="fade-up">
                <div className='popup-image' style={styles}></div>
                <div className='popup-content'>
                <h1 >{title}</h1>
                <p>{desc}</p>
                </div>
                <div className='popup-button'><button className="button" onClick={close}>
                  <span className="lable">close</span>
                </button></div>
           </div>
    </section>
  )
}
